import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'

import initBugsnag from '@/helpers/initBugsnag'
import { createJwxI18n } from '@/i18n'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp(App);
const bugsnagVue = initBugsnag('Lifestyle Web - Favorites');

app.use(pinia);
app.use(bugsnagVue)
app.use(createJwxI18n(navigator.language))
app.mount('#favorites');